<template>
  <section class="how-we-work container">
    <div class="section-head">
      <h2 class="section-title">
        How we Work ?
      </h2>
    </div>

    <ul class="card-list card-container">
      <li class="card">
        <div class="icon-container">
          <img
            :src="HowWeWorkImage1"
            class="icon"
            alt=""
          >
        </div>

        <p class="card-desc">
          Ask your question—it’s free and anonymous.
        </p>
      </li>

      <li class="card">
        <div class="icon-container">
          <img
            :src="HowWeWorkImage2"
            class="icon"
            alt=""
          >
        </div>

        <p class="card-desc">
          Get notified when a lawyer responds—usually within 24 hours.
        </p>
      </li>

      <li class="card">
        <div class="icon-container">
          <img
            :src="HowWeWorkImage3"
            class="icon"
            alt=""
          >
        </div>

        <p class="card-desc">
          Ask follow-up questions—make sure you understand your options.
        </p>
      </li>
    </ul>
  </section>
</template>

<script>
import HowWeWorkImage1 from '@/images/how-we-work-01.svg'
import HowWeWorkImage2 from '@/images/how-we-work-02.svg'
import HowWeWorkImage3 from '@/images/how-we-work-03.svg'

export default {
  name: 'HowWeWork',
  setup() {
    return {
      HowWeWorkImage1,
      HowWeWorkImage2,
      HowWeWorkImage3,
    }
  },
}
</script>
<style lang="scss" scoped>
  @import '@/sass/module/home_how-we-work';
</style>
